import React, { Component } from 'react';
import { secondsTypefy } from '../../utils/tools';
import playImg from '../../static/images/play_share.png';
import pauseImg from '../../static/images/pause_share.png';
import './style.less';


class Share extends Component {
    constructor(props){
        super(props);
        this.state = {
            isPlay:false,
            duration:0,
            currentTime:0,
            img:playImg
        };
        this.audio = new Audio();        
        this.audioPlay = this.audioPlay.bind(this);
        this.audioPause = this.audioPause.bind(this);
        this.handleClick = props.handleClick;
    }
    audioPlay(){
        this.audio.play();
        this.interval = setInterval(()=>{
            console.log((this.state.currentTime/this.state.duration-0.03)*100);
            this.setState({
                currentTime:this.audio.currentTime
            })
        },100)
        console.log(this.audio.currentTime)
        this.setState({isPlay:true,img:pauseImg});
    }
    audioPause(){
        this.audio.pause();
        this.setState({isPlay:false,img:playImg});
        clearInterval(this.interval);
    }
    componentWillReceiveProps(){
        if(this.props.audioUrl) this.audio.src = this.props.audioUrl;
        this.audio.src = this.props.audioUrl;
    }
    render(){
        const _this = this;
        const _list = this.props.list || [];
        const listItem = _list.map((ele,index)=>{
            return(
                <li key={index} style={{backgroundImage:`url(${ele.courseDetailCoverHPhoto}?x-oss-process=image/resize,w_490)`}}
                onClick={()=>{_this.props.handlePush(ele.classSchId)}}
                >
                    <div className="btn"></div> 
                    <div className="title">{ele.courseDetailEnName}</div>
                </li>
            )
        })
        this.audio.oncanplaythrough = function(){
            _this.setState({
                duration:Math.round(this.duration)
            });
        }
        return(
            <div className="container share">
                <div className="top">
                    <div className="user_img">
                        <img src={this.props.stuPortrait} alt="用户头像"/>
                    </div>
                    <div className="user_info">
                        <div className="name">你的好友<span>{this.props.stuEnName}</span></div>
                        <div>邀你一起来参与Air Course</div>
                    </div>
                    <div className="btn">打开</div>
                </div>
                <div className="middle">
                    <div className="player_top" style={{backgroundImage:`url(${this.props.courseDetailGroupMpPhoto}?x-oss-process=image/resize,w_1000)`}}>
                        <div className="player_title">{this.props.courseDetailEnName}</div>
                        <div className="player_control">
                            <div className="player_start" 
                            onClick={()=>{if(this.state.isPlay) 
                            this.audioPause(); else this.audioPlay()}}
                            style={{backgroundImage:`url(${this.state.img})`}}
                            ></div>
                            {/* <div className="player_start" onClick={()=>{this.setState({isPlay:true});alert(this.state.isPlay)}}></div> */}
                            <div className="player_time">{secondsTypefy(this.state.currentTime)}</div>
                            <div className="player_bar">
                                <div className="insert" style={{right:`${((1-(this.state.currentTime/this.state.duration))*100)}%`}}></div>
                                <div className="pointer" style={{left:`${(this.state.currentTime/this.state.duration-0.03)*100}%`}}></div>
                            </div>
                            <div className="player_end">{secondsTypefy(this.state.duration)}</div>
                            {/* <audio ref={this.audio} src={this.props.audioUrl} controls></audio> */}
                        </div>
                    </div>
                    <div className="player_bottom">
                        <div className="user_img">
                            <img src={this.props.stuPortrait} alt="用户头像"/>                        
                        </div>
                        <div className="user_name">{this.props.stuEnName}</div>
                        <div className="btn" onClick={this.handleClick}>
                            <span>分享</span>
                            <span className="icon"></span>
                        </div>
                    </div>
                </div>
                <div className="bottom">
                    <div className="head">更多作品</div>
                    <ul>
                        {listItem}
                    </ul>
                </div>
            </div>
        )
    }
}

export default Share;



// WEBPACK FOOTER //
// ./src/template/Share/Share.jsx